const imagePath = '/images/cases/design-991/decorations/'

export const config = {
  title: 'application map',
  image: {
    src: `${imagePath}application-map.webp`,
    alt: 'application map',
    fill: true,
  },
}
